import React from "react";
import { components } from "react-select";
import { Icon, arrowDown, arrowUp } from "Icons/index";

export default props => {
  if (props.selectProps.menuIsOpen) {
    return (
      <components.DropdownIndicator {...props}>
        <Icon svg={arrowUp} width="0.75rem" height="0.75rem" />
      </components.DropdownIndicator>
    );
  } else {
    return (
      <components.DropdownIndicator {...props}>
        <Icon svg={arrowDown} width="0.75rem" height="0.75rem" />
      </components.DropdownIndicator>
    );
  }
};
